import React, {Component} from 'react';
import {Route, Switch, Redirect, NavLink, Link} from 'react-router-dom';
import {getCurrentUserId, getJwt} from '../../../services/authService';
import http from '../../../services/httpService';
import {Intent, Callout} from '@blueprintjs/core/lib/esm/index';
import ReactGA from "react-ga";
import StripeReplacementModal from '../../modals/StripeReplacementModal';
import BillingInvoices from './BillingInvoices';
import BillingPaymentMethods from './BillingPaymentMethods';
import BillingPreferences from './BillingPreferences';
import BillingSubscriptions from './BillingSubscriptions';
import toastr from 'toastr';
import SinglePaymentMethod from './SinglePaymentMethod';
import Joyride, {STATUS} from "react-joyride";

class Billing extends Component {
    state = {
        activeStep: 3,
        loader: false,
        projectDefault: '',
        viberActive: false,
        viberCredit: 0,
        projectBalance: '',
        stripeReplacementModal: false,
        tourRun: false,
        steps: [
            {
                content: "All your subscriptions, invoices and billing details are located here. ☝️",
                placement: 'right',
                spotlightPadding: 0,
                styles: {
                    options: {
                        zIndex: 10000,
                    },
                },
                target: '.billing-tour-step-1',
                title: '',
            },
            {
                content: "Preview, download or print your Invoices from this section of your account.\n",
                placement: 'right',
                spotlightPadding: 0,
                styles: {
                    options: {
                        zIndex: 10000,
                    },
                },
                target: '.billing-tour-step-2',
                title: '',
            },
            {
                content: "If you find Emitto super valuable, you can easily upgrade your plan from here. 😉\n" +
                    "Also, here you can also find all your Subscriptions.",
                placement: 'right',
                spotlightPadding: 0,
                styles: {
                    options: {
                        zIndex: 10000,
                    },
                },
                target: '.billing-tour-step-3',
                title: '',
            },
            {
                content: "All your credit cards used for payments are here. 💳",
                placement: 'right',
                spotlightPadding: 0,
                styles: {
                    options: {
                        zIndex: 10000,
                    },
                },
                target: '.billing-tour-step-4',
                title: '',
            },
            {
                content: "Let's set-up your first Channel. 💪",
                placement: 'center',
                spotlightPadding: 0,
                styles: {
                    options: {
                        zIndex: 10000,
                    },
                },
                target: '.billing-tour-step-5',
                title: '',
            },
        ]
    };

    analytics = () => {
        // ReactGA.set({userId: getCurrentUserId()});
        // ReactGA.pageview(window.location.pathname + window.location.search);
    };

    componentDidMount = () => {
        if (this.props.location.state) {
            if (this.props.location.state === 'first-workspace') {
                //console.log('run the first workspace')
                setTimeout(
                    () => {
                        this.setState({
                            tourRun: true,
                            steps: [
                                {
                                    content: "You can preview your workspace balance and top up from here. ☝️",
                                    placement: 'bottom',
                                    spotlightPadding: 0,
                                    styles: {
                                        options: {
                                            zIndex: 10000,
                                        },
                                    },
                                    disableBeacon: true,
                                    target: '.billing-tour-step-1',
                                    title: '',
                                },
                                {
                                    content: "Preview, download or print your Invoices from this section of your account.\n",
                                    placement: 'bottom',
                                    spotlightPadding: 0,
                                    styles: {
                                        options: {
                                            zIndex: 10000,
                                        },
                                    },
                                    target: '.billing-tour-step-2',
                                    title: '',
                                },
                                {
                                    content: "If you find Emitto super valuable, you can easily upgrade your plan from here. 😉\n" +
                                        "Also, here you can also find all your Subscriptions.",
                                    placement: 'bottom',
                                    spotlightPadding: 0,
                                    styles: {
                                        options: {
                                            zIndex: 10000,
                                        },
                                    },
                                    target: '.billing-tour-step-3',
                                    title: '',
                                },
                                {
                                    content: "All your credit cards used for payments are here. 💳",
                                    placement: 'bottom',
                                    spotlightPadding: 0,
                                    styles: {
                                        options: {
                                            zIndex: 10000,
                                        },
                                    },
                                    target: '.billing-tour-step-4',
                                    title: '',
                                },
                                {
                                    content: "Let's set-up your first Channel. 💪",
                                    placement: 'center',
                                    spotlightPadding: 0,
                                    styles: {
                                        options: {
                                            zIndex: 10000,
                                        },
                                    },
                                    target: '.billing-tour-step-5',
                                    title: '',
                                },
                            ]
                        })
                    },
                    1000);
            }
        }

        this.analytics();
        const user_id = getCurrentUserId();

        if (window.location.pathname === '/billing/invoices') {
            this.setState({activeStep: 1})
        } else if (window.location.pathname === '/billing/subscriptions') {
            this.setState({activeStep: 2})
        } else if (window.location.pathname === '/billing/balance') {
            this.setState({activeStep: 3})
        } else {
            this.setState({activeStep: 4})
        }
        if (!this.state.projectId) {
            this.setState({projectId: this.props.selectedSource})
        }
        if (this.props.subscription_renewal_problem) {
            this.getPaymentMethods()
        }
        this.handleCheckViber()
        if (this.props.selectedSourceNode && this.props.selectedSourceNode.project_balance) {
            this.setState({projectBalance: this.props.selectedSourceNode.project_balance})
        }
    }

    async componentDidUpdate() {
        if (window.location.pathname === '/billing/invoices' && this.state.activeStep !== 1) {
            this.setState({activeStep: 1})
        } else if (window.location.pathname === '/billing/subscriptions' && this.state.activeStep !== 2) {
            this.setState({activeStep: 2})
        } else if (window.location.pathname === '/billing/balance' && this.state.activeStep !== 3) {
            this.setState({activeStep: 3})
        } else if (window.location.pathname === '/billing/payment-methods' && this.state.activeStep !== 4) {
            this.setState({activeStep: 4})
        }
        // console.log('getPaymentMethods u componentDidUpdate: ', this.props.subscription_renewal_problem, this.props.selectedSource.toString(), this.state.projectId.toString());
        if (this.props.selectedSource && ((this.props.selectedSource.toString() !== this.state.projectId.toString()))) {
            this.setState({projectId: this.props.selectedSource})
            this.getPaymentMethods()
            this.handleCheckViber()
            // console.log('billing: ', this.props.selectedSourceNode.projectBalance)
            if (this.props.selectedSourceNode && this.props.selectedSourceNode.project_balance) {
                // console.log('billing: Usao 1')
                this.setState({projectBalance: this.props.selectedSourceNode.project_balance})
            } else {
                // console.log('billing: Usao 2')
                this.setState({projectBalance: ''})
            }
        }
    }

    getHelpers = (StoreHelpers) => {
        this.helpers = StoreHelpers;
    };

    handleJoyrideCallback = (data) => {
        //console.log('joyride callback data: ', data)

        const {status} = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            this.setState({tourRun: false});
        }
        if (data.index === 1) {
            this.props.history.push('/billing/invoices')
        }
        if (data.index === 2) {
            this.props.history.push('/billing/subscriptions')

        }
        if (data.index === 3) {
            this.props.history.push('/billing/payment-methods')

        }
        if (data.index === 4 && data.status === "finished") {
            this.props.history.push('/channels', 'first-workspace')

        }
    }

    handleCheckViber = () => {
        let viberClient = this.props.selectedSourceNode && this.props.selectedSourceNode.viber_client ? this.props.selectedSourceNode.viber_client : '';

        //console.log('viberClient: ', viberClient)
        if (viberClient) {
            this.setState({
                viberActive: true,
                viberCredit: viberClient.available_credit ? parseInt(viberClient.available_credit).toFixed(2) : '0.00'
            })
        } else {
            if (this.state.viberActive) {
                this.setState({
                    viberActive: false,
                    viberCredit: ''
                })
            }
        }

        // alphanumericId = await this.state.selectedSourceFull[0].viber_client.brand_name
        // }
    }

    handleStepChange = (step) => {
        this.setState({activeStep: step})
        this.props.history.push('/billing/' + step === 1 ? 'invoices' : step === 2 ? 'subscriptions' : step === 3 ? 'preferences' : 'payment-methods')
    }

    getPaymentMethods = async () => {
        let user = await this.props.user;
        let projectId = await localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        // console.log('getPaymentMethods: ', user, projectId);
        if (user && user.customer) {
            /*GET PAYMENT METHODS PROJECT*/
            try {
                const result = await http.get('/api/user/' + user.id + '/project/' + projectId + '/customers/get_payment_methods_project', {headers: {authorization: getJwt()}});
                // console.log('Payment Methods: ', result)
                if (result.data.project_payment_methods) {
                    result.data.project_payment_methods.map(method => method.project_default && (!this.state.projectDefault || this.state.projectDefault !== method.id) ? this.setState({projectDefault: method}) : '')
                }
            } catch (e) {
                toastr.error("Couldn't get payment methods.")
            }
        }
    }

    render() {
        const {tourRun, steps} = this.state
        return (
            <div className='billing-wrapper'>
                <Joyride
                    callback={this.handleJoyrideCallback}
                    continuous={true}
                    getHelpers={this.getHelpers}
                    run={this.state.tourRun}
                    //scrollToFirstStep={true}
                    showProgress={true}
                    showSkipButton={true}
                    steps={steps}
                    styles={{
                        options: {
                            zIndex: 10000,
                            primaryColor: '#26AAE1'
                        },
                    }}
                />
                <h1 className='main-title'>Billing</h1>

                <div className="top-navigation">
                    <div className="navigation-wrapper ">
                        <div className="menu-link">
                            <NavLink className='billing-tour-step-1' to="/billing/balance"
                                     onClick={() => this.handleStepChange(3)}>
                                <span className={this.state.activeStep === 3 ? 'active' : 'nonactive'}>Balance</span>
                            </NavLink>
                        </div>
                        <div className="menu-link ">
                            <NavLink className='billing-tour-step-2' to="/billing/invoices"
                                     onClick={() => this.handleStepChange(1)}>
                                <span className={this.state.activeStep === 1 ? 'active' : 'nonactive'}>Invoices</span>
                            </NavLink>
                        </div>
                        <div className="menu-link">
                            <NavLink className='billing-tour-step-3' to="/billing/subscriptions"
                                     onClick={() => this.handleStepChange(2)}>
                                <span
                                    className={this.state.activeStep === 2 ? 'active' : 'nonactive'}>Subscriptions</span>
                            </NavLink>
                        </div>
                        <div className="menu-link">
                            <NavLink className='billing-tour-step-4' to="/billing/payment-methods"
                                     onClick={() => this.handleStepChange(4)}>
                                <span className={this.state.activeStep === 4 ? 'active' : 'nonactive'}>Payment
                                    Methods</span>
                            </NavLink>
                        </div>
                    </div>
                    <button className='btn-action absolute-right-button'
                            onClick={() => this.props.history.push('/top-up/add-credits')}>Add Credits
                    </button>
                    {/*<button className='btn-action absolute-right-button' onClick={()=>this.setState({stripeReplacementModal: true})}>Add Credits</button>*/}
                </div>
                {this.props.subscription_renewal_problem ?
                    <div className='renewal-problem-wrapper'>
                        <Callout icon='warning-sign' intent={Intent.WARNING} className='callout-style'>
                            Something is wrong with your payment method.
                        </Callout>
                        <p>There was a problem with renewing your subscription. In order to enjoy all the perks that
                            comes
                            with your subscription plan, please check your default payment method. </p>
                        {this.state.projectDefault ?
                            <div className='payment-error-wrapper'>
                                <SinglePaymentMethod
                                    method={this.state.projectDefault}
                                    user={this.props.user}
                                    type={'paymentError'}
                                    updateMethodsList={this.getPaymentMethods}
                                    history={this.props.history}
                                    updatePaymentMethods={this.getPaymentMethods}
                                    project={this.state.project}
                                    selectedSource={this.props.selectedSource}
                                />
                                <button className='btn-action margin-left-20'>Try Again</button>
                            </div>
                            :
                            ''
                        }
                        <p>If problem still occurs try setting another payment method as default or add a new one.</p>
                    </div>
                    :
                    ''
                }
                <div className='main billing-tour-step-5'>
                    {/*Router starts*/}
                    <Switch>
                        <Route path="/billing/invoices"
                               render={(props) => <BillingInvoices
                                   handleStepChange={this.handleStepChange}
                                   user={this.props.user}
                                   selectedSource={this.props.selectedSource}
                                   isodateToDate={this.props.isodateToDate}
                                   {...props}
                               />
                               }
                        />
                        <Route path="/billing/subscriptions"
                               render={(props) => <BillingSubscriptions
                                   user={this.props.user}
                                   handleStepChange={this.handleStepChange}
                                   updateUserFromServer={this.props.updateUserFromServer}
                                   selectedSource={this.props.selectedSource}
                                   isodateToDate={this.props.isodateToDate}
                                   {...props}/>
                               }/>
                        <Route path='/billing/preferences'>
                            <Redirect to='/billing/balance'/>
                        </Route>
                        <Route path="/billing/balance"
                               render={(props) => <BillingPreferences
                                   user={this.props.user}
                                   selectedSourceNode={this.props.selectedSourceNode}
                                   selectedSource={this.props.selectedSource}
                                   handleStepChange={this.handleStepChange}
                                   viberActive={this.state.viberActive}
                                   viberCredit={this.state.viberCredit}
                                   projectBalance={this.props.selectedSourceNode && this.props.selectedSourceNode.project_balance ?
                                       this.props.selectedSourceNode.project_balance : ''}
                                   updateUserFromServer={this.props.updateUserFromServer}
                                   isodateToDate={this.props.isodateToDate}
                                   {...props}/>
                               }/>
                        <Route path="/billing/payment-methods"
                               render={(props) => <BillingPaymentMethods
                                   handleStepChange={this.handleStepChange}
                                   user={this.props.user}
                                   selectedSource={this.props.selectedSource}
                                   subscription_renewal_problem={this.props.subscription_renewal_problem}
                                   updateUserFromServer={this.props.updateUserFromServer}
                                   isodateToDate={this.props.isodateToDate}
                                   {...props}/>
                               }/>
                    </Switch>
                </div>
                {/*<StripeReplacementModal*/}
                {/*    showModal={this.state.stripeReplacementModal}*/}
                {/*    handleClose={() => this.setState({stripeReplacementModal: false})}*/}
                {/*    maxWidth={600}*/}
                {/*    history={this.props.history}*/}
                {/*    user={this.props.user}*/}
                {/*    updateUserFromServer={this.props.updateUserFromServer}*/}
                {/*/>*/}
            </div>
        )
    }
}

export default Billing

